// This file is AUTOGENERATED, do not edit it manually!!!

import { projectFinancials as projectFinancialsde } from './projectFinancialsResx.de';
import { projectFinancials as projectFinancialsen } from './projectFinancialsResx.en';
import { projectFinancials as projectFinancialsen_risk } from './projectFinancialsResx.en_risk';
import { projectFinancials as projectFinancialses } from './projectFinancialsResx.es';
import { projectFinancials as projectFinancialsfr } from './projectFinancialsResx.fr';
import { projectFinancials as projectFinancialsit } from './projectFinancialsResx.it';
import { projectFinancials as projectFinancialsnl } from './projectFinancialsResx.nl';
import { projectFinancials as projectFinancialspl } from './projectFinancialsResx.pl';
import { projectFinancials as projectFinancialspt } from './projectFinancialsResx.pt';
import { projectFinancials as projectFinancialsru } from './projectFinancialsResx.ru';
import { projectFinancials as projectFinancialssk } from './projectFinancialsResx.sk';
import { projectFinancials as projectFinancialssv } from './projectFinancialsResx.sv';
import { projectFinancials as projectFinancialstr } from './projectFinancialsResx.tr';

const langMap: { [k: string]: Partial<typeof projectFinancialsen> } = {
    de: projectFinancialsde,
    en: projectFinancialsen,
    en_risk: projectFinancialsen_risk,
    es: projectFinancialses,
    fr: projectFinancialsfr,
    it: projectFinancialsit,
    nl: projectFinancialsnl,
    pl: projectFinancialspl,
    pt: projectFinancialspt,
    ru: projectFinancialsru,
    sk: projectFinancialssk,
    sv: projectFinancialssv,
    tr: projectFinancialstr,
};

/* tslint:disable: max-line-length */
export const projectFinancialsResx = {
    /**
    * en: Actual billable
    */
    get actual_billing() {
        return langMap[ep.resxCulture].actual_billing || langMap.en.actual_billing;
    },
    /**
    * en: Actual cost
    */
    get actual_cost() {
        return langMap[ep.resxCulture].actual_cost || langMap.en.actual_cost;
    },
    /**
    * en: Actual billable expenses
    */
    get ActualBillableExpenses() {
        return langMap[ep.resxCulture].ActualBillableExpenses || langMap.en.ActualBillableExpenses;
    },
    /**
    * en: Actual billable expenses
    */
    get ActualBillableExpensesShort() {
        return langMap[ep.resxCulture].ActualBillableExpensesShort || langMap.en.ActualBillableExpensesShort;
    },
    /**
    * en: Actual invoiced
    */
    get ActualBilledShort() {
        return langMap[ep.resxCulture].ActualBilledShort || langMap.en.ActualBilledShort;
    },
    /**
    * en: Actual billable
    */
    get ActualBillingShort() {
        return langMap[ep.resxCulture].ActualBillingShort || langMap.en.ActualBillingShort;
    },
    /**
    * en: Actual budget perform
    */
    get ActualBudgetProfitability() {
        return langMap[ep.resxCulture].ActualBudgetProfitability || langMap.en.ActualBudgetProfitability;
    },
    /**
    * en: Actual cost
    */
    get ActualCost() {
        return langMap[ep.resxCulture].ActualCost || langMap.en.ActualCost;
    },
    /**
    * en: Actual cost = Actual labor cost + Actual expenses
    */
    get ActualCostQtip() {
        return langMap[ep.resxCulture].ActualCostQtip || langMap.en.ActualCostQtip;
    },
    /**
    * en: Actual expenses
    */
    get ActualExpenses() {
        return langMap[ep.resxCulture].ActualExpenses || langMap.en.ActualExpenses;
    },
    /**
    * en: Actual
    */
    get ActualExpensesListTitle() {
        return langMap[ep.resxCulture].ActualExpensesListTitle || langMap.en.ActualExpensesListTitle;
    },
    /**
    * en: Actual expenses
    */
    get ActualExpensesShort() {
        return langMap[ep.resxCulture].ActualExpensesShort || langMap.en.ActualExpensesShort;
    },
    /**
    * en: Actual hours
    */
    get ActualHours() {
        return langMap[ep.resxCulture].ActualHours || langMap.en.ActualHours;
    },
    /**
    * en: Actual billable labor
    */
    get ActualLaborBilling() {
        return langMap[ep.resxCulture].ActualLaborBilling || langMap.en.ActualLaborBilling;
    },
    /**
    * en: Actual billable labor
    */
    get ActualLaborBillingShort() {
        return langMap[ep.resxCulture].ActualLaborBillingShort || langMap.en.ActualLaborBillingShort;
    },
    /**
    * en: Actual labor cost
    */
    get ActualLaborCost() {
        return langMap[ep.resxCulture].ActualLaborCost || langMap.en.ActualLaborCost;
    },
    /**
    * en: Actual labor cost
    */
    get ActualLaborCostShort() {
        return langMap[ep.resxCulture].ActualLaborCostShort || langMap.en.ActualLaborCostShort;
    },
    /**
    * en: add activities flat fees
    */
    get add_activities_flat_fees() {
        return langMap[ep.resxCulture].add_activities_flat_fees || langMap.en.add_activities_flat_fees;
    },
    /**
    * en: Add as actual expense
    */
    get add_as_actual_expense() {
        return langMap[ep.resxCulture].add_as_actual_expense || langMap.en.add_as_actual_expense;
    },
    /**
    * en: add planned billable expenses
    */
    get add_planned_billable_expenses() {
        return langMap[ep.resxCulture].add_planned_billable_expenses || langMap.en.add_planned_billable_expenses;
    },
    /**
    * en: Add received payment
    */
    get add_received_payment() {
        return langMap[ep.resxCulture].add_received_payment || langMap.en.add_received_payment;
    },
    /**
    * en: Add scheduled payment
    */
    get add_scheduled_payment() {
        return langMap[ep.resxCulture].add_scheduled_payment || langMap.en.add_scheduled_payment;
    },
    /**
    * en: add activities budgets
    */
    get AddActivitiesBudgets() {
        return langMap[ep.resxCulture].AddActivitiesBudgets || langMap.en.AddActivitiesBudgets;
    },
    /**
    * en: Add budget for this project
    */
    get AddBudgetLabel() {
        return langMap[ep.resxCulture].AddBudgetLabel || langMap.en.AddBudgetLabel;
    },
    /**
    * en: add planned expenses
    */
    get AddPlannedExpenses() {
        return langMap[ep.resxCulture].AddPlannedExpenses || langMap.en.AddPlannedExpenses;
    },
    /**
    * en: Amount
    */
    get Amount() {
        return langMap[ep.resxCulture].Amount || langMap.en.Amount;
    },
    /**
    * en: Approver
    */
    get approver_label() {
        return langMap[ep.resxCulture].approver_label || langMap.en.approver_label;
    },
    /**
    * en: One of the approvers can no longer approve expenses. Update the approvers list.
    */
    get approvers_problem_warning() {
        return langMap[ep.resxCulture].approvers_problem_warning || langMap.en.approvers_problem_warning;
    },
    /**
    * en: Transfers planned expenses to actual ones
    */
    get ApproveTooltip() {
        return langMap[ep.resxCulture].ApproveTooltip || langMap.en.ApproveTooltip;
    },
    /**
    * en: Back to metrics
    */
    get back_to_metrics() {
        return langMap[ep.resxCulture].back_to_metrics || langMap.en.back_to_metrics;
    },
    /**
    * en: Add as Actual expenses
    */
    get batch_actual_text() {
        return langMap[ep.resxCulture].batch_actual_text || langMap.en.batch_actual_text;
    },
    /**
    * en: Approve expenses
    */
    get batch_approval_text() {
        return langMap[ep.resxCulture].batch_approval_text || langMap.en.batch_approval_text;
    },
    /**
    * en: Mark as invoiced
    */
    get batch_billed_text() {
        return langMap[ep.resxCulture].batch_billed_text || langMap.en.batch_billed_text;
    },
    /**
    * en: The operation could not be completed for this expenses. This may be due to its having been deleted or lacking permissions to perform operations with it. Consult with your {brandName} administrator for possible causes.
    */
    get batch_operation_failed_description() {
        return langMap[ep.resxCulture].batch_operation_failed_description || langMap.en.batch_operation_failed_description;
    },
    /**
    * en: The operation could not be completed for {0} out of {1} expenses. This may be due to them having been deleted or lacking permissions to perform operations with them. Consult with your {brandName} administrator for possible causes.
    */
    get batch_operations_failed_description() {
        return langMap[ep.resxCulture].batch_operations_failed_description || langMap.en.batch_operations_failed_description;
    },
    /**
    * en: Reject expenses
    */
    get batch_reject_text() {
        return langMap[ep.resxCulture].batch_reject_text || langMap.en.batch_reject_text;
    },
    /**
    * en: Billable
    */
    get Billable() {
        return langMap[ep.resxCulture].Billable || langMap.en.Billable;
    },
    /**
    * en: Invoiced
    */
    get Billed() {
        return langMap[ep.resxCulture].Billed || langMap.en.Billed;
    },
    /**
    * en: Invoiced = (Invoiced labor + Invoiced expenses) / EAC billable * 100%
    */
    get BilledPercentQtip() {
        return langMap[ep.resxCulture].BilledPercentQtip || langMap.en.BilledPercentQtip;
    },
    /**
    * en: Invoiced vs Actual cost
    */
    get BilledVsActualCost() {
        return langMap[ep.resxCulture].BilledVsActualCost || langMap.en.BilledVsActualCost;
    },
    /**
    * en: Billable
    */
    get Billing() {
        return langMap[ep.resxCulture].Billing || langMap.en.Billing;
    },
    /**
    * en: Billing info
    */
    get Billing_Info_Title() {
        return langMap[ep.resxCulture].Billing_Info_Title || langMap.en.Billing_Info_Title;
    },
    /**
    * en: Editing is not available in the grid when the billing type is Rate card. You can edit it in the Financials section
    */
    get billing_type_item_readonly() {
        return langMap[ep.resxCulture].billing_type_item_readonly || langMap.en.billing_type_item_readonly;
    },
    /**
    * en: In the Billing section you can choose the right type of billing for your project and set a rate, such as hourly, or a fixed amount for a flat fee project.
    */
    get BillingHelp() {
        return langMap[ep.resxCulture].BillingHelp || langMap.en.BillingHelp;
    },
    /**
    * en: Billing settings
    */
    get BillingSettings() {
        return langMap[ep.resxCulture].BillingSettings || langMap.en.BillingSettings;
    },
    /**
    * en: Billing
    */
    get BillingSettingsTitle() {
        return langMap[ep.resxCulture].BillingSettingsTitle || langMap.en.BillingSettingsTitle;
    },
    /**
    * en: Billing type
    */
    get BillingType() {
        return langMap[ep.resxCulture].BillingType || langMap.en.BillingType;
    },
    /**
    * en: Calculate by 
    */
    get BillingTypeLabel() {
        return langMap[ep.resxCulture].BillingTypeLabel || langMap.en.BillingTypeLabel;
    },
    /**
    * en: Upfront billing utilization
    */
    get BillingUtilization() {
        return langMap[ep.resxCulture].BillingUtilization || langMap.en.BillingUtilization;
    },
    /**
    * en: Total project budget
    */
    get BudgetedCost() {
        return langMap[ep.resxCulture].BudgetedCost || langMap.en.BudgetedCost;
    },
    /**
    * en: In this section you can view the total budget of the project as composed of that of all its activities, and set a project level budget.
    */
    get BudgetHelp() {
        return langMap[ep.resxCulture].BudgetHelp || langMap.en.BudgetHelp;
    },
    /**
    * en: Cancel
    */
    get CancelTooltip() {
        return langMap[ep.resxCulture].CancelTooltip || langMap.en.CancelTooltip;
    },
    /**
    * en: Actual billable
    */
    get chart_actual_billing() {
        return langMap[ep.resxCulture].chart_actual_billing || langMap.en.chart_actual_billing;
    },
    /**
    * en: Actual cost
    */
    get chart_actual_cost() {
        return langMap[ep.resxCulture].chart_actual_cost || langMap.en.chart_actual_cost;
    },
    /**
    * en: Billable expenses
    */
    get chart_billable_expenses() {
        return langMap[ep.resxCulture].chart_billable_expenses || langMap.en.chart_billable_expenses;
    },
    /**
    * en: Invoiced
    */
    get chart_billed() {
        return langMap[ep.resxCulture].chart_billed || langMap.en.chart_billed;
    },
    /**
    * en: Invoiced expenses
    */
    get chart_billed_expenses() {
        return langMap[ep.resxCulture].chart_billed_expenses || langMap.en.chart_billed_expenses;
    },
    /**
    * en: EAC billable
    */
    get chart_eac_billing() {
        return langMap[ep.resxCulture].chart_eac_billing || langMap.en.chart_eac_billing;
    },
    /**
    * en: Expenses
    */
    get chart_expenses() {
        return langMap[ep.resxCulture].chart_expenses || langMap.en.chart_expenses;
    },
    /**
    * en: Non-billable expenses
    */
    get chart_non_billable_expenses() {
        return langMap[ep.resxCulture].chart_non_billable_expenses || langMap.en.chart_non_billable_expenses;
    },
    /**
    * en: Received payments
    */
    get chart_payments() {
        return langMap[ep.resxCulture].chart_payments || langMap.en.chart_payments;
    },
    /**
    * en: Scheduled payments
    */
    get chart_scheduled_payments() {
        return langMap[ep.resxCulture].chart_scheduled_payments || langMap.en.chart_scheduled_payments;
    },
    /**
    * en: Contingency
    */
    get ContingencyPadding() {
        return langMap[ep.resxCulture].ContingencyPadding || langMap.en.ContingencyPadding;
    },
    /**
    * en: Total cost
    */
    get Cost() {
        return langMap[ep.resxCulture].Cost || langMap.en.Cost;
    },
    /**
    * en: CPI
    */
    get CPI() {
        return langMap[ep.resxCulture].CPI || langMap.en.CPI;
    },
    /**
    * en: Currency
    */
    get CurrencyLabel() {
        return langMap[ep.resxCulture].CurrencyLabel || langMap.en.CurrencyLabel;
    },
    /**
    * en: Customer hourly rate
    */
    get CustomerHourlyRateLabel() {
        return langMap[ep.resxCulture].CustomerHourlyRateLabel || langMap.en.CustomerHourlyRateLabel;
    },
    /**
    * en: Date
    */
    get Date() {
        return langMap[ep.resxCulture].Date || langMap.en.Date;
    },
    /**
    * en: Delete the expense
    */
    get delete_the_expense_title() {
        return langMap[ep.resxCulture].delete_the_expense_title || langMap.en.delete_the_expense_title;
    },
    /**
    * en: Delete the payment
    */
    get delete_the_payment_title() {
        return langMap[ep.resxCulture].delete_the_payment_title || langMap.en.delete_the_payment_title;
    },
    /**
    * en: Are you sure you want delete this record?
    */
    get DeletePaymentConfirmation() {
        return langMap[ep.resxCulture].DeletePaymentConfirmation || langMap.en.DeletePaymentConfirmation;
    },
    /**
    * en: Delete
    */
    get DeleteTooltip() {
        return langMap[ep.resxCulture].DeleteTooltip || langMap.en.DeleteTooltip;
    },
    /**
    * en: Description
    */
    get Description() {
        return langMap[ep.resxCulture].Description || langMap.en.Description;
    },
    /**
    * en: Detailed report for {0}
    */
    get DetailedReportTitleTemplate() {
        return langMap[ep.resxCulture].DetailedReportTitleTemplate || langMap.en.DetailedReportTitleTemplate;
    },
    /**
    * en: Estimate at completion
    */
    get EAC() {
        return langMap[ep.resxCulture].EAC || langMap.en.EAC;
    },
    /**
    * en: Estimate at completion (EAC) billable
    */
    get eac_billing() {
        return langMap[ep.resxCulture].eac_billing || langMap.en.eac_billing;
    },
    /**
    * en: Estimate at completion (EAC) cost
    */
    get eac_cost() {
        return langMap[ep.resxCulture].eac_cost || langMap.en.eac_cost;
    },
    /**
    * en: EAC billable
    */
    get EACBilling() {
        return langMap[ep.resxCulture].EACBilling || langMap.en.EACBilling;
    },
    /**
    * en: Estimate at completion (EAC) billable
    */
    get EACBillingLong() {
        return langMap[ep.resxCulture].EACBillingLong || langMap.en.EACBillingLong;
    },
    /**
    * en: Estimate at completion (EAC) billable = Actual billable + ETC billable
    */
    get EACBillingQtip() {
        return langMap[ep.resxCulture].EACBillingQtip || langMap.en.EACBillingQtip;
    },
    /**
    * en: Estimated total billable amount including billable labor and billable expenses (Actual + Estimate to completion (ETC))
    */
    get EACBillingQtipInfo() {
        return langMap[ep.resxCulture].EACBillingQtipInfo || langMap.en.EACBillingQtipInfo;
    },
    /**
    * en: Estimate at completion (EAC) cost
    */
    get EACCost() {
        return langMap[ep.resxCulture].EACCost || langMap.en.EACCost;
    },
    /**
    * en: EAC cost
    */
    get EACCost_short() {
        return langMap[ep.resxCulture].EACCost_short || langMap.en.EACCost_short;
    },
    /**
    * en: Estimate at completion (EAC) cost = Actual cost + ETC cost
    */
    get EACCostQtip() {
        return langMap[ep.resxCulture].EACCostQtip || langMap.en.EACCostQtip;
    },
    /**
    * en: Entered by
    */
    get EnteredBy() {
        return langMap[ep.resxCulture].EnteredBy || langMap.en.EnteredBy;
    },
    /**
    * en: Estimated budget profitability
    */
    get EstimatedBudgetProfitability() {
        return langMap[ep.resxCulture].EstimatedBudgetProfitability || langMap.en.EstimatedBudgetProfitability;
    },
    /**
    * en: Estimated cost variance
    */
    get EstimatedCostVariance() {
        return langMap[ep.resxCulture].EstimatedCostVariance || langMap.en.EstimatedCostVariance;
    },
    /**
    * en: Estimated expenses
    */
    get EstimatedExpenses() {
        return langMap[ep.resxCulture].EstimatedExpenses || langMap.en.EstimatedExpenses;
    },
    /**
    * en: Estimated hours
    */
    get EstimatedHours() {
        return langMap[ep.resxCulture].EstimatedHours || langMap.en.EstimatedHours;
    },
    /**
    * en: Expected profit
    */
    get EstimatedProfit() {
        return langMap[ep.resxCulture].EstimatedProfit || langMap.en.EstimatedProfit;
    },
    /**
    * en: Expected profit (%) = (EAC billable - EAC cost) / EAC billable * 100%
    */
    get EstimatedProfitPercentQtip() {
        return langMap[ep.resxCulture].EstimatedProfitPercentQtip || langMap.en.EstimatedProfitPercentQtip;
    },
    /**
    * en: Expected profit = EAC billable - EAC cost
    */
    get EstimatedProfitQtip() {
        return langMap[ep.resxCulture].EstimatedProfitQtip || langMap.en.EstimatedProfitQtip;
    },
    /**
    * en: Estimate to completion (ETC) billable
    */
    get etc_billing() {
        return langMap[ep.resxCulture].etc_billing || langMap.en.etc_billing;
    },
    /**
    * en: Estimate to completion (ETC) cost
    */
    get etc_cost() {
        return langMap[ep.resxCulture].etc_cost || langMap.en.etc_cost;
    },
    /**
    * en: ETC billable expenses
    */
    get ETCBillableExpenses() {
        return langMap[ep.resxCulture].ETCBillableExpenses || langMap.en.ETCBillableExpenses;
    },
    /**
    * en: ETC billable expenses
    */
    get ETCBillableExpensesShort() {
        return langMap[ep.resxCulture].ETCBillableExpensesShort || langMap.en.ETCBillableExpensesShort;
    },
    /**
    * en: ETC billable
    */
    get ETCBilling() {
        return langMap[ep.resxCulture].ETCBilling || langMap.en.ETCBilling;
    },
    /**
    * en: ETC billable
    */
    get ETCBillingShort() {
        return langMap[ep.resxCulture].ETCBillingShort || langMap.en.ETCBillingShort;
    },
    /**
    * en: ETC cost
    */
    get ETCCost() {
        return langMap[ep.resxCulture].ETCCost || langMap.en.ETCCost;
    },
    /**
    * en: ETC cost
    */
    get ETCCostShort() {
        return langMap[ep.resxCulture].ETCCostShort || langMap.en.ETCCostShort;
    },
    /**
    * en: Estimate to completion (ETC) cost = ETC labor cost + ETC expenses
    */
    get ETCCosttQtip() {
        return langMap[ep.resxCulture].ETCCosttQtip || langMap.en.ETCCosttQtip;
    },
    /**
    * en: ETC expenses
    */
    get ETCExpenses() {
        return langMap[ep.resxCulture].ETCExpenses || langMap.en.ETCExpenses;
    },
    /**
    * en: ETC expenses
    */
    get ETCExpensesShort() {
        return langMap[ep.resxCulture].ETCExpensesShort || langMap.en.ETCExpensesShort;
    },
    /**
    * en: ETC billable labor
    */
    get ETCLaborBilling() {
        return langMap[ep.resxCulture].ETCLaborBilling || langMap.en.ETCLaborBilling;
    },
    /**
    * en: ETC billable labor
    */
    get ETCLaborBillingShort() {
        return langMap[ep.resxCulture].ETCLaborBillingShort || langMap.en.ETCLaborBillingShort;
    },
    /**
    * en: ETC labor cost
    */
    get ETCLaborCost() {
        return langMap[ep.resxCulture].ETCLaborCost || langMap.en.ETCLaborCost;
    },
    /**
    * en: ETC labor cost
    */
    get ETCLaborCostShort() {
        return langMap[ep.resxCulture].ETCLaborCostShort || langMap.en.ETCLaborCostShort;
    },
    /**
    * en: Expected revenue
    */
    get ExpectedRevenue() {
        return langMap[ep.resxCulture].ExpectedRevenue || langMap.en.ExpectedRevenue;
    },
    /**
    * en: 1#{0} expense#{0} expenses
    */
    get expenses() {
        return langMap[ep.resxCulture].expenses || langMap.en.expenses;
    },
    /**
    * en: Enables expenses approval for the entire project and all its activities.
    */
    get expenses_approval_info() {
        return langMap[ep.resxCulture].expenses_approval_info || langMap.en.expenses_approval_info;
    },
    /**
    * en: Expenses approval
    */
    get expenses_approval_label() {
        return langMap[ep.resxCulture].expenses_approval_label || langMap.en.expenses_approval_label;
    },
    /**
    * en: Removes all approvers, which disables the expense approval process after saving.
    */
    get expenses_approval_remove_all_approvers_title() {
        return langMap[ep.resxCulture].expenses_approval_remove_all_approvers_title || langMap.en.expenses_approval_remove_all_approvers_title;
    },
    /**
    * en: Approved
    */
    get expenses_approval_status_approved() {
        return langMap[ep.resxCulture].expenses_approval_status_approved || langMap.en.expenses_approval_status_approved;
    },
    /**
    * en: 1#Approval has been successfully undone#{0} approvals have been successfully undone
    */
    get expenses_approval_status_has_been_successfully_undone() {
        return langMap[ep.resxCulture].expenses_approval_status_has_been_successfully_undone || langMap.en.expenses_approval_status_has_been_successfully_undone;
    },
    /**
    * en: Waiting for approval
    */
    get expenses_approval_status_none() {
        return langMap[ep.resxCulture].expenses_approval_status_none || langMap.en.expenses_approval_status_none;
    },
    /**
    * en: Rejected
    */
    get expenses_approval_status_rejected() {
        return langMap[ep.resxCulture].expenses_approval_status_rejected || langMap.en.expenses_approval_status_rejected;
    },
    /**
    * en: 1#Expense has been approved#{0} expenses have been approved
    */
    get expenses_approved_successfully_plural() {
        return langMap[ep.resxCulture].expenses_approved_successfully_plural || langMap.en.expenses_approved_successfully_plural;
    },
    /**
    * en: 1#Expense has been rejected#{0} expenses have been rejected
    */
    get expenses_rejected_successfully_plural() {
        return langMap[ep.resxCulture].expenses_rejected_successfully_plural || langMap.en.expenses_rejected_successfully_plural;
    },
    /**
    * en: 1#Expenses has been updated successfully.#{0} expenses have been updated successfully.
    */
    get expenses_updated_successfully_plural() {
        return langMap[ep.resxCulture].expenses_updated_successfully_plural || langMap.en.expenses_updated_successfully_plural;
    },
    /**
    * en: Fee amount
    */
    get FeeAmount() {
        return langMap[ep.resxCulture].FeeAmount || langMap.en.FeeAmount;
    },
    /**
    * en: Flat fee
    */
    get FlatFee() {
        return langMap[ep.resxCulture].FlatFee || langMap.en.FlatFee;
    },
    /**
    * en: General info
    */
    get GeneralInfo() {
        return langMap[ep.resxCulture].GeneralInfo || langMap.en.GeneralInfo;
    },
    /**
    * en: Hourly rate
    */
    get HourlyRate() {
        return langMap[ep.resxCulture].HourlyRate || langMap.en.HourlyRate;
    },
    /**
    * en: Budget
    */
    get InternalBudget() {
        return langMap[ep.resxCulture].InternalBudget || langMap.en.InternalBudget;
    },
    /**
    * en: Estimated cost
    */
    get InternalEstimatedCost() {
        return langMap[ep.resxCulture].InternalEstimatedCost || langMap.en.InternalEstimatedCost;
    },
    /**
    * en: Billable labor
    */
    get LaborBilling() {
        return langMap[ep.resxCulture].LaborBilling || langMap.en.LaborBilling;
    },
    /**
    * en: Labor cost
    */
    get LaborCost() {
        return langMap[ep.resxCulture].LaborCost || langMap.en.LaborCost;
    },
    /**
    * en: Actual
    */
    get legend_actual() {
        return langMap[ep.resxCulture].legend_actual || langMap.en.legend_actual;
    },
    /**
    * en: Estimate at completion
    */
    get legend_estimated_at_completion() {
        return langMap[ep.resxCulture].legend_estimated_at_completion || langMap.en.legend_estimated_at_completion;
    },
    /**
    * en: Log actual expense
    */
    get log_actual_expense() {
        return langMap[ep.resxCulture].log_actual_expense || langMap.en.log_actual_expense;
    },
    /**
    * en: Log expenses
    */
    get log_expenses() {
        return langMap[ep.resxCulture].log_expenses || langMap.en.log_expenses;
    },
    /**
    * en: Log payments
    */
    get log_payments() {
        return langMap[ep.resxCulture].log_payments || langMap.en.log_payments;
    },
    /**
    * en: Log planned expense
    */
    get log_planned_expense() {
        return langMap[ep.resxCulture].log_planned_expense || langMap.en.log_planned_expense;
    },
    /**
    * en: {0} for {1}?
    */
    get money_for_date_label() {
        return langMap[ep.resxCulture].money_for_date_label || langMap.en.money_for_date_label;
    },
    /**
    * en: No targets to display
    */
    get no_targets() {
        return langMap[ep.resxCulture].no_targets || langMap.en.no_targets;
    },
    /**
    * en: There are no expenses.
    */
    get NoActualExpenses() {
        return langMap[ep.resxCulture].NoActualExpenses || langMap.en.NoActualExpenses;
    },
    /**
    * en: None
    */
    get None() {
        return langMap[ep.resxCulture].None || langMap.en.None;
    },
    /**
    * en: Choose currency
    */
    get NoneCurrency() {
        return langMap[ep.resxCulture].NoneCurrency || langMap.en.NoneCurrency;
    },
    /**
    * en: There are no payments.
    */
    get NoPayments() {
        return langMap[ep.resxCulture].NoPayments || langMap.en.NoPayments;
    },
    /**
    * en: There are no planned expenses.
    */
    get NoPlannedExpenses() {
        return langMap[ep.resxCulture].NoPlannedExpenses || langMap.en.NoPlannedExpenses;
    },
    /**
    * en: Not billable
    */
    get NotBillable() {
        return langMap[ep.resxCulture].NotBillable || langMap.en.NotBillable;
    },
    /**
    * en: Not billable
    */
    get NotBillableLabel() {
        return langMap[ep.resxCulture].NotBillableLabel || langMap.en.NotBillableLabel;
    },
    /**
    * en: Not invoiced
    */
    get NotBilled() {
        return langMap[ep.resxCulture].NotBilled || langMap.en.NotBilled;
    },
    /**
    * en: Open rate card
    */
    get OpenRateCard() {
        return langMap[ep.resxCulture].OpenRateCard || langMap.en.OpenRateCard;
    },
    /**
    * en: Outstanding payment balance
    */
    get OutstandingPaymentBalance() {
        return langMap[ep.resxCulture].OutstandingPaymentBalance || langMap.en.OutstandingPaymentBalance;
    },
    /**
    * en: Description...
    */
    get PaymentDescriptionWatermark() {
        return langMap[ep.resxCulture].PaymentDescriptionWatermark || langMap.en.PaymentDescriptionWatermark;
    },
    /**
    * en: Payment received
    */
    get PaymentReceived() {
        return langMap[ep.resxCulture].PaymentReceived || langMap.en.PaymentReceived;
    },
    /**
    * en: 1#{0} payment#{0} payments
    */
    get payments_total() {
        return langMap[ep.resxCulture].payments_total || langMap.en.payments_total;
    },
    /**
    * en: Payments of sched. payments
    */
    get PaymentsOfSchedPayments() {
        return langMap[ep.resxCulture].PaymentsOfSchedPayments || langMap.en.PaymentsOfSchedPayments;
    },
    /**
    * en: Percentage invoiced
    */
    get PercentageBilled() {
        return langMap[ep.resxCulture].PercentageBilled || langMap.en.PercentageBilled;
    },
    /**
    * en: Percentage invoiced
    */
    get PercentageProjectBilled() {
        return langMap[ep.resxCulture].PercentageProjectBilled || langMap.en.PercentageProjectBilled;
    },
    /**
    * en: Percentage
    */
    get Percentages() {
        return langMap[ep.resxCulture].Percentages || langMap.en.Percentages;
    },
    /**
    * en: Planned expenses
    */
    get PlannedExpenses() {
        return langMap[ep.resxCulture].PlannedExpenses || langMap.en.PlannedExpenses;
    },
    /**
    * en: Planned
    */
    get PlannedExpensesListTitle() {
        return langMap[ep.resxCulture].PlannedExpensesListTitle || langMap.en.PlannedExpensesListTitle;
    },
    /**
    * en: {0}pp
    */
    get ppFormat() {
        return langMap[ep.resxCulture].ppFormat || langMap.en.ppFormat;
    },
    /**
    * en: Profit
    */
    get Profit() {
        return langMap[ep.resxCulture].Profit || langMap.en.Profit;
    },
    /**
    * en: Profit = Actual billable - Actual cost
    */
    get ProfitQtip() {
        return langMap[ep.resxCulture].ProfitQtip || langMap.en.ProfitQtip;
    },
    /**
    * en: You must specify a rate card if project billing is based on rate card.
    */
    get Project_no_rateCard_for_rateCard_billingType() {
        return langMap[ep.resxCulture].Project_no_rateCard_for_rateCard_billingType || langMap.en.Project_no_rateCard_for_rateCard_billingType;
    },
    /**
    * en: Project / Activity name
    */
    get ProjectActivityName() {
        return langMap[ep.resxCulture].ProjectActivityName || langMap.en.ProjectActivityName;
    },
    /**
    * en: Project billing
    */
    get ProjectBilling() {
        return langMap[ep.resxCulture].ProjectBilling || langMap.en.ProjectBilling;
    },
    /**
    * en: Project billing is based on
    */
    get ProjectBillingIsBasedOn() {
        return langMap[ep.resxCulture].ProjectBillingIsBasedOn || langMap.en.ProjectBillingIsBasedOn;
    },
    /**
    * en: Billing utilization
    */
    get ProjectBillingUtilization() {
        return langMap[ep.resxCulture].ProjectBillingUtilization || langMap.en.ProjectBillingUtilization;
    },
    /**
    * en: Labor budget
    */
    get ProjectBudget() {
        return langMap[ep.resxCulture].ProjectBudget || langMap.en.ProjectBudget;
    },
    /**
    * en: Project internal cost
    */
    get ProjectCost() {
        return langMap[ep.resxCulture].ProjectCost || langMap.en.ProjectCost;
    },
    /**
    * en: Project cost variance
    */
    get ProjectCostVariance() {
        return langMap[ep.resxCulture].ProjectCostVariance || langMap.en.ProjectCostVariance;
    },
    /**
    * en: Project earned value
    */
    get ProjectEarnedValue() {
        return langMap[ep.resxCulture].ProjectEarnedValue || langMap.en.ProjectEarnedValue;
    },
    /**
    * en: Represents project health
    */
    get ProjectEarnedValueInfo() {
        return langMap[ep.resxCulture].ProjectEarnedValueInfo || langMap.en.ProjectEarnedValueInfo;
    },
    /**
    * en: Project expected revenue
    */
    get ProjectExpectedRevenue() {
        return langMap[ep.resxCulture].ProjectExpectedRevenue || langMap.en.ProjectExpectedRevenue;
    },
    /**
    * en: Project flat fee
    */
    get ProjectFixedCostLabel() {
        return langMap[ep.resxCulture].ProjectFixedCostLabel || langMap.en.ProjectFixedCostLabel;
    },
    /**
    * en: Project hourly rate
    */
    get ProjectHourlyRateLabel() {
        return langMap[ep.resxCulture].ProjectHourlyRateLabel || langMap.en.ProjectHourlyRateLabel;
    },
    /**
    * en: Project payments
    */
    get ProjectPayments() {
        return langMap[ep.resxCulture].ProjectPayments || langMap.en.ProjectPayments;
    },
    /**
    * en: Project planned expenses
    */
    get ProjectPlannedExpenses() {
        return langMap[ep.resxCulture].ProjectPlannedExpenses || langMap.en.ProjectPlannedExpenses;
    },
    /**
    * en: Expenses planned for a specific project and planned expenses aggregated from its activities
    */
    get ProjectPlannedExpensesInfo() {
        return langMap[ep.resxCulture].ProjectPlannedExpensesInfo || langMap.en.ProjectPlannedExpensesInfo;
    },
    /**
    * en: Project profit
    */
    get ProjectProfit() {
        return langMap[ep.resxCulture].ProjectProfit || langMap.en.ProjectProfit;
    },
    /**
    * en: Project profitability
    */
    get ProjectProfitability() {
        return langMap[ep.resxCulture].ProjectProfitability || langMap.en.ProjectProfitability;
    },
    /**
    * en: Represents  the percentage of value created per project
    */
    get ProjectProfitabilityInfo() {
        return langMap[ep.resxCulture].ProjectProfitabilityInfo || langMap.en.ProjectProfitabilityInfo;
    },
    /**
    * en: Project time usage
    */
    get ProjectTimeUsage() {
        return langMap[ep.resxCulture].ProjectTimeUsage || langMap.en.ProjectTimeUsage;
    },
    /**
    * en: Displays how much of the time budgeted we've used, actual as a percentage of estimated hours
    */
    get ProjectTimeUsageInfo() {
        return langMap[ep.resxCulture].ProjectTimeUsageInfo || langMap.en.ProjectTimeUsageInfo;
    },
    /**
    * en: Project work in progress
    */
    get ProjectWorkInProgress() {
        return langMap[ep.resxCulture].ProjectWorkInProgress || langMap.en.ProjectWorkInProgress;
    },
    /**
    * en: Payments vs Actual cost
    */
    get PymentsVsActualCost() {
        return langMap[ep.resxCulture].PymentsVsActualCost || langMap.en.PymentsVsActualCost;
    },
    /**
    * en: Rate card
    */
    get RateCardLabel() {
        return langMap[ep.resxCulture].RateCardLabel || langMap.en.RateCardLabel;
    },
    /**
    * en: Receipt
    */
    get Receipt() {
        return langMap[ep.resxCulture].Receipt || langMap.en.Receipt;
    },
    /**
    * en: Received
    */
    get Received() {
        return langMap[ep.resxCulture].Received || langMap.en.Received;
    },
    /**
    * en: Received
    */
    get ReceivedPaymentsListTitle() {
        return langMap[ep.resxCulture].ReceivedPaymentsListTitle || langMap.en.ReceivedPaymentsListTitle;
    },
    /**
    * en: Remaining budget
    */
    get RemainingInternalBudget() {
        return langMap[ep.resxCulture].RemainingInternalBudget || langMap.en.RemainingInternalBudget;
    },
    /**
    * en: Remaining budget = Budget - Actual cost
    */
    get RemainingInternalBudgetQtip() {
        return langMap[ep.resxCulture].RemainingInternalBudgetQtip || langMap.en.RemainingInternalBudgetQtip;
    },
    /**
    * en: Remaining budget = Total budget - Actual cost
    */
    get RemainingInternalBudgetQtipForProject() {
        return langMap[ep.resxCulture].RemainingInternalBudgetQtipForProject || langMap.en.RemainingInternalBudgetQtipForProject;
    },
    /**
    * en: Resource hourly rate
    */
    get ResourceHourlyRateLabel() {
        return langMap[ep.resxCulture].ResourceHourlyRateLabel || langMap.en.ResourceHourlyRateLabel;
    },
    /**
    * en: Revenue
    */
    get Revenue() {
        return langMap[ep.resxCulture].Revenue || langMap.en.Revenue;
    },
    /**
    * en: Editing this expense will reset its status to Waiting for approval and restart the approval process from the beginning. Any previous approvals or rejections will be lost. Do you want to proceed?
    */
    get revert_approval_text() {
        return langMap[ep.resxCulture].revert_approval_text || langMap.en.revert_approval_text;
    },
    /**
    * en: Revert expense for reapproval?
    */
    get revert_approval_title() {
        return langMap[ep.resxCulture].revert_approval_title || langMap.en.revert_approval_title;
    },
    /**
    * en: Scheduled
    */
    get Scheduled() {
        return langMap[ep.resxCulture].Scheduled || langMap.en.Scheduled;
    },
    /**
    * en: Scheduled
    */
    get ScheduledPaymentsListTitle() {
        return langMap[ep.resxCulture].ScheduledPaymentsListTitle || langMap.en.ScheduledPaymentsListTitle;
    },
    /**
    * en: Set targets using the
    */
    get set_targets() {
        return langMap[ep.resxCulture].set_targets || langMap.en.set_targets;
    },
    /**
    * en: Settings
    */
    get Settings() {
        return langMap[ep.resxCulture].Settings || langMap.en.Settings;
    },
    /**
    * en: Waiting for approval from me
    */
    get show_expenses_waiting_for_my_approval() {
        return langMap[ep.resxCulture].show_expenses_waiting_for_my_approval || langMap.en.show_expenses_waiting_for_my_approval;
    },
    /**
    * en: SHOW ALL
    */
    get ShowAll() {
        return langMap[ep.resxCulture].ShowAll || langMap.en.ShowAll;
    },
    /**
    * en: Show breakdown
    */
    get ShowBreakdown() {
        return langMap[ep.resxCulture].ShowBreakdown || langMap.en.ShowBreakdown;
    },
    /**
    * en: SHOW FULL
    */
    get ShowFull() {
        return langMap[ep.resxCulture].ShowFull || langMap.en.ShowFull;
    },
    /**
    * en: SPI
    */
    get SPI() {
        return langMap[ep.resxCulture].SPI || langMap.en.SPI;
    },
    /**
    * en: Status
    */
    get status_label() {
        return langMap[ep.resxCulture].status_label || langMap.en.status_label;
    },
    /**
    * en: Actual expenses
    */
    get tab_Actual() {
        return langMap[ep.resxCulture].tab_Actual || langMap.en.tab_Actual;
    },
    /**
    * en: Expenses
    */
    get tab_expenses() {
        return langMap[ep.resxCulture].tab_expenses || langMap.en.tab_expenses;
    },
    /**
    * en: Overview
    */
    get tab_overview() {
        return langMap[ep.resxCulture].tab_overview || langMap.en.tab_overview;
    },
    /**
    * en: Payments
    */
    get tab_payments() {
        return langMap[ep.resxCulture].tab_payments || langMap.en.tab_payments;
    },
    /**
    * en: Planned expenses
    */
    get tab_Planned() {
        return langMap[ep.resxCulture].tab_Planned || langMap.en.tab_Planned;
    },
    /**
    * en: Received payments
    */
    get tab_Received() {
        return langMap[ep.resxCulture].tab_Received || langMap.en.tab_Received;
    },
    /**
    * en: Scheduled payments
    */
    get tab_Scheduled() {
        return langMap[ep.resxCulture].tab_Scheduled || langMap.en.tab_Scheduled;
    },
    /**
    * en: Targets
    */
    get tab_targets() {
        return langMap[ep.resxCulture].tab_targets || langMap.en.tab_targets;
    },
    /**
    * en: Total budget
    */
    get TargetBudget() {
        return langMap[ep.resxCulture].TargetBudget || langMap.en.TargetBudget;
    },
    /**
    * en: Target labor revenue
    */
    get TargetLaborRevenue() {
        return langMap[ep.resxCulture].TargetLaborRevenue || langMap.en.TargetLaborRevenue;
    },
    /**
    * en: Target profit
    */
    get TargetProfit() {
        return langMap[ep.resxCulture].TargetProfit || langMap.en.TargetProfit;
    },
    /**
    * en: Target revenue
    */
    get TargetRevenue() {
        return langMap[ep.resxCulture].TargetRevenue || langMap.en.TargetRevenue;
    },
    /**
    * en: Targets
    */
    get Targets() {
        return langMap[ep.resxCulture].Targets || langMap.en.Targets;
    },
    /**
    * en: Targets tab
    */
    get targets_tab() {
        return langMap[ep.resxCulture].targets_tab || langMap.en.targets_tab;
    },
    /**
    * en: EAC billable
    */
    get TargetsEACBilling() {
        return langMap[ep.resxCulture].TargetsEACBilling || langMap.en.TargetsEACBilling;
    },
    /**
    * en: Activity rate
    */
    get TaskRateLabel() {
        return langMap[ep.resxCulture].TaskRateLabel || langMap.en.TaskRateLabel;
    },
    /**
    * en: Time & material
    */
    get TimeAndMaterial() {
        return langMap[ep.resxCulture].TimeAndMaterial || langMap.en.TimeAndMaterial;
    },
    /**
    * en: Time usage
    */
    get TimeUsage() {
        return langMap[ep.resxCulture].TimeUsage || langMap.en.TimeUsage;
    },
    /**
    * en: Financials
    */
    get TitleText() {
        return langMap[ep.resxCulture].TitleText || langMap.en.TitleText;
    },
    /**
    * en: Total billable
    */
    get total_billable() {
        return langMap[ep.resxCulture].total_billable || langMap.en.total_billable;
    },
    /**
    * en: Total invoiced
    */
    get TotalBilled() {
        return langMap[ep.resxCulture].TotalBilled || langMap.en.TotalBilled;
    },
    /**
    * en: Total project budget
    */
    get TotalProjectBudget() {
        return langMap[ep.resxCulture].TotalProjectBudget || langMap.en.TotalProjectBudget;
    },
    /**
    * en: Total project payments
    */
    get TotalProjectPayments() {
        return langMap[ep.resxCulture].TotalProjectPayments || langMap.en.TotalProjectPayments;
    },
    /**
    * en: Summary of all payments made by all customers
    */
    get TotalProjectPaymentsInfo() {
        return langMap[ep.resxCulture].TotalProjectPaymentsInfo || langMap.en.TotalProjectPaymentsInfo;
    },
    /**
    * en: Total target revenue
    */
    get TotalTargetRevenue() {
        return langMap[ep.resxCulture].TotalTargetRevenue || langMap.en.TotalTargetRevenue;
    },
    /**
    * en: Track profit as
    */
    get TrackProfitAs() {
        return langMap[ep.resxCulture].TrackProfitAs || langMap.en.TrackProfitAs;
    },
    /**
    * en: Date is a required field.
    */
    get Validation_DateMandatory() {
        return langMap[ep.resxCulture].Validation_DateMandatory || langMap.en.Validation_DateMandatory;
    },
    /**
    * en: Amount must be positive number.
    */
    get Validation_InvalidAmount() {
        return langMap[ep.resxCulture].Validation_InvalidAmount || langMap.en.Validation_InvalidAmount;
    },
    /**
    * en: Date must be in '{0}' format.
    */
    get Validation_InvalidDate() {
        return langMap[ep.resxCulture].Validation_InvalidDate || langMap.en.Validation_InvalidDate;
    },
    /**
    * en: Value doesn't fall within the expected range.
    */
    get Validation_Range() {
        return langMap[ep.resxCulture].Validation_Range || langMap.en.Validation_Range;
    },
    /**
    * en: Variance
    */
    get Variance() {
        return langMap[ep.resxCulture].Variance || langMap.en.Variance;
    },
    /**
    * en: Currency is taken from chosen rate card
    */
    get warning_currency() {
        return langMap[ep.resxCulture].warning_currency || langMap.en.warning_currency;
    },
    /**
    * en: Work in progress
    */
    get WorkInProgress() {
        return langMap[ep.resxCulture].WorkInProgress || langMap.en.WorkInProgress;
    },
};

// @ts-ignore
ep.resources = ep.resources || {};

// @ts-ignore
ep.resources.projectFinancials = projectFinancialsResx;
